<template>
  <div class="modal fade" id="confirmDeleteModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div style="width: 100%">
            <h5>Delete Confirmation</h5>
          </div>
          <div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <h6>
            Are you sure you want to delete {{ DeletingTitle }}?
            <b
              >You will NOT be able to get this back. It will be deleted
              FOREVER.</b
            >
          </h6>
          <div class="row text-left">
            <div class="col">
              <button
                type="button"
                class="btn btn-secondary"
                v-on:click="cancel"
              >
                Cancel
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-danger"
                v-on:click="$emit('confirm-delete')"
              >
                Delete Data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    DeletingTitle: String
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      $("#confirmDeleteModal").modal("hide");
    }
  }
};
</script>
